module.exports = __webpack_public_path__ + "img/蔬菜.24d8f822.png";